import { Inject, Injectable } from '@angular/core';
import {
  ShopConfigs,
  ShopConfigsRepository,
  ShopErrorMessages
} from '@infrab4a/connect';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class ShopConfigService extends BaseConnectService<ShopConfigs> {
  constructor(
    @Inject('ShopConfigsRepository')
    private shopConfigsRepository: ShopConfigsRepository
  ) {
    super(shopConfigsRepository);
  }

  async getErrorsList() {
    const result = (
      await this.shopConfigsRepository.find({}).then((res) => res.data?.at(0))
    ).errors as ShopErrorMessages[];

    return result;
  }

  async updateError(error: Partial<ShopErrorMessages>) {
    const shopConfigs = await this.shopConfigsRepository
      .find({})
      .then((res) => res.data?.at(0));

    const existingErrors = shopConfigs?.errors || [];
    const updatedErrors = existingErrors.map((e) =>
      e.code === error.code ? { ...e, ...error } : e
    );

    return this.shopConfigsRepository.update(
      ShopConfigs.toInstance({
        ...shopConfigs,
        errors: updatedErrors
      })
    );
  }
}
